<template>
<div>
    
    <div class="app-content content devcontent ">
        <div class="content-overlay"></div>
        <div class="header-navbar-shadow"></div>
        <div class="content-wrapper">
            <div class="content-header-left mb-1 pt-0 pad_top_mar_bot-5">
                <div class="container-fluid">
                   <div class="row breadcrumbs-top">
                      <div class="col-md-12 content-header-left px-0">
                        <h3 class="content-header-title float-left mb-0" > Floor Capacity </h3>
                        
                        <div class="breadcrumb-wrapper">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"><router-link to='/outbound/floor-plan-view'>Outbound</router-link>
                                </li>
                                <li class="breadcrumb-item">Floor Plan View
                                </li>
                            </ol>
                        </div>
                        
                        
                      </div>
                   </div>
                </div>
                
            </div>
            <section>
                <div class="card container px-0">
                    <div class="card-header px-0  common_top_title_searchbgst_dock">
                            <div class="container-fluid " >
                                <div class="row row fc_my-05">
                                    <div class="w-auto px-1 mobile-padding-0-2">
                                        <div class="avatar bg-light-secondary rounded d-inline-flex mr-1" >
                                            <div class="avatar-content">
                                                
                                                <em class="las la-vector-square i_icon_st font-medium-5"></em>
                                                
                                            </div>
                                        </div>
                                        
                                        <h4 class="card-title d-inline-flex ml-0 mb-0">Outbound Shipment summary </h4>
                                    </div>
                                </div>    
                                    
                            </div>
                        </div>
                    <div class=" p-1 outboundview_designmobileview5">
                         <div class="second_outboundview_design">
                            <!-- <p class="px-0">Shipment summary for last 24 Hours</p> -->
                           
                            <!-- <div class="row mb-1 mt-1">
                                <div class="col-3 ">
                                    <input class="form-control" v-model="no_of_days" type="number" min="1" max="365" step="1" @keypress="isNumber($event)" placeholder="Enter Number of days"/>
                                </div>
                                <div class="col-2">
                                    <button type="button" class="btn--export" @click="getShipmentSummary()">Fetch</button> 
                                </div>
                            </div> -->
                            <div class="container px-0">
                                <div class="table-responsive">
                                    <table class="table table-bordered">
                                        <thead>
                                            <tr>
                                            <th> Total Shipments </th>
                                            <th> Total Weight (KG) </th>
                                            <th> Total in process </th>
                                            <th> Not scanned </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <vue-element-loading :active="isShipmentSummaryLoading" color="#FF6700"/>
                                            <tr>
                                                <td> {{shipmentSummary.total_shipments}}</td>
                                                <td> {{roundNumber(shipmentSummary.total_weight)}}</td>
                                                <td> {{shipmentSummary.total_in_process ? shipmentSummary.total_in_process : '0' }}</td>
                                                <td> {{shipmentSummary.not_scanned ? shipmentSummary.not_scanned : '0'}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="jumbotron_bg dashboard_secondview mb-1">

                                <div class="container mt-1"> 
                                    <div class="table-responsive mb-5">
                                        <table class="table de_outboundview">
                                            <thead>
                                                <template v-for="(dock, idx) in floors.slice(0, Math.ceil(floors.length/2))">
                                                    <th ><div class="th_color"> {{dock.dock_name}}</div></th>
                                                </template>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <template v-for="(dock, idx2) in floors.slice(0, Math.ceil(floors.length/2))">
                                                        <td> 
                                                            <ul class="sectors_design" v-if="dock.zone_name">
                                                                <template v-for="(sector, idx3) in dock.zone_name.split(',')">
                                                                   <li :id="dock.dock_name+'___'+sector" class="sector" @click="selectSector($event, sector, dock.dock_name, idx3)">{{sector}}</li> 
                                                                </template>
                                                            </ul>
                                                            <ul v-else>
                                                                <li>{{""}}</li>
                                                            </ul>
                                                        </td>
                                                    </template>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <vue-element-loading :active="isFloorLoading" color="#19A873" />
                                        <div class="empty_div_height"> </div>
                                        <table class="table de_outboundview tbody_contentviewbottom">
                                            <tbody>
                                                <tr>
                                                    <template v-for="(dock, idx2) in floors.slice(Math.ceil(floors.length/2))">
                                                        <td> 
                                                            <ul class="sectors_design" v-if="dock.zone_name">
                                                                <template v-for="(sector, idx3) in dock.zone_name.split(',')">
                                                                   <li :id="dock.dock_name+'___'+sector" class="sector" @click="selectSector($event, sector, dock.dock_name, idx3)">{{sector}}</li> 
                                                                </template>
                                                            </ul>
                                                            <ul v-else>
                                                                <li>{{""}}</li>
                                                            </ul>
                                                        </td>
                                                    </template>
                                                </tr>
                                            </tbody>
                                            <thead class="">
                                                <template v-for="(dock, idx) in floors.slice(Math.ceil(floors.length/2))">
                                                    <th ><div class="th_color"> {{dock.dock_name}}</div></th>
                                                </template>
                                            </thead>
                                        </table>
                                    </div>
                                </div>
                              </div>
                            <div class="container px-0">
                                <div class="row match-height">
                                    <div class="col-sm-6 col-md-4"> 
                                        <div class="jumbotron_bg dashboard_third_dview">
                                            <div class="palletstrip"> {{ dock ? dock : "No Dock Selected" }}</div>
                                            <vue-element-loading :active="isPalletLoading" color="#800080"/>
                                            <ul v-if="pallets.length && pallets[0].pallet_code">

                                                <!-- <template v-for="(palletObj, idx) in pallets">
                                                    <template v-for="(pallet, idx2) in palletObj.pallet_code.split(',')">
                                                        <li :class="[ getPalletCurrentWeight(pallet)  > 500 ? 'heavy' : '', 'pallet']" class="pallet" :id="dock+'___'+sector+'___'+pallet" @click="selectPallet($event, pallet, palletObj.gate_entry_id, idx)">
                                                        {{pallet}}
                                                        </li>
                                                    </template>
                                                    
                                                </template> -->
                                                <!-- <template v-for="(count, cidx) in Array(36-pallets[0].pallet_code.split(',').length).fill(0)">
                                                    <li style="background-color: #fff">L {{cidx+pallets[0].pallet_code.split(',').length+1}}</li>
                                                </template> -->
                                                <template v-for="(palletObj, idx) in pallets.slice(0,1)">
                                                    <template v-for="(cidx, count) in sequencer">
                                                        <!-- {{cidx}} -->
                                                        <li 
                                                            style="position:relative" 
                                                            v-if="getPalletCode(pallets[0].pallet_code, cidx-1)[1]" 
                                                            :class="[ getPalletCurrentWeight(getPalletCode(pallets[0].pallet_code, cidx-1)[0], getPalletCode(pallets[0].pallet_code, cidx-1)[1])  >= 2000 ? 'heavy' : '', 'pallet']" 
                                                            class="pallet" 
                                                            :id="dock+'___'+sector+'___'+getPalletCode(pallets[0].pallet_code, cidx-1)[0]" 
                                                            @click="selectPallet($event, getPalletCode(pallets[0].pallet_code, cidx-1)[0], palletObj.gate_entry_id, idx)" >
                                                            <span class="top-badge">{{getPalletCode(pallets[0].pallet_code, cidx-1)[2]}}</span>
                                                            {{getPalletCode(pallets[0].pallet_code, cidx-1)[0]}}    
                                                        </li>
                                                        <li v-else style="background-color: #fff">{{getPalletCode(pallets[0].pallet_code, cidx-1)[0]}}</li>
                                                    </template>
                                                </template>
                                            </ul>
                                            <ul v-else>
                                                <template v-for="(cidx, count) in sequencer">
                                                    <li style="background-color: #fff; position:relative">L{{ cidx <= 9 ? '0'+(cidx) : cidx}}</li>
                                                </template>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 col-md-8"> 
                                        <div class="jumbotron_bg dashboard_third_dview p-0">
                                            <vue-element-loading :active="isPackagesLoading" color="#FF6700"/>
                                            <div class="row mx-0 mt-1  match-height customAnimation">

                                                <div class="col-lg-6 col-sm-6 col-12 card_crossdock_main_padding">
                                                    <div class="card cursor-pointer card_bottom_line_animation  mb-1" >
                                                        <div class="card-header p-1">
                                                        <div class="task-count-width_w">
                                                            <p class="card-text mx-0">{{sector}} </p>
                                                            <h2 class="font-weight-bolder mb-0" ><span class="mr-1" style="font-weight:400; font-size: 12px">Physical Weight</span>{{roundNumber(getTotalWeightOnSector())}} KG</h2>
                                                            <h2 class="font-weight-bolder mb-0" ><span class="mr-1" style="font-weight:400; font-size: 12px">Volumetric Weight</span>-</h2>
                                                        </div>
                                                        <div class=" bg-light-default p-50 m-0">
                                                            <div class="avatar-content avatar_iconsview1">
                                                                
                                                                <img alt=""  class="img-reponsive" src="../../public/images/icons/kg.png">
                                                            </div>
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-6 col-sm-6 col-12 card_crossdock_main_padding">
                                                <div class="card cursor-pointer card_bottom_line_animation bottom_bg_bor3bg mb-1" >
                                                    <div class="card-header p-1">
                                                    <div class="task-count-width_w">
                                                        <p class="card-text mx-0">{{pallet ? pallet : "Pallet Not Selected"}} {{pallet ? ' (Package Details)' : ""}} </p>
                                                        <h5 class="font-weight-bolder mb-0" >{{pallet ? 'Total = ' + totalcount : ''}} </h5>
                                                        <h5 class="font-weight-bolder mb-0" >{{pallet ? 'Pallet Weight = ' + roundNumber(getPalletCurrentWeight(pallet)) + 'KG' : ''}} </h5>
                                                      
                                                    </div>
                                                    <div class=" bg-light-default p-50 m-0">
                                                        <div class="avatar-content avatar_iconsview1">
                                                            <img alt=""  class="img-responsive" src="../../public/images/icons/pakeges.png">  
                                                        </div>
                                                    </div>
                                                    </div>
                                                </div>
                                            </div>
                                            </div>
                                            <div class="container">
                                                 <div class="table-responsive">
                                                    
                                                    <table class="table table-bordered">
                                                        <thead>
                                                            <tr>
                                                            <th> Package No. </th>
                                                            <th> Delivery OU </th>
                                                            <th> Package OU </th>
                                                            <th> Package Weight (KG)</th>
                                                            <th> ADD </th>
                                                            <th> Ageing </th>
                                                            </tr>
                                                            
                                                        </thead>
                                                        <tbody>
                                                            <template v-for="(packageDetails, idx) in packages">
                                                                <tr>
                                                                    <td> {{packageDetails.shipment_awb}}</td>
                                                                    <td> {{packageDetails.delivery_ou}}</td>
                                                                    <td> {{packageDetails.booking_ou}}</td>
                                                                    <td> {{roundNumber(packageDetails.package_weight)}}</td>
                                                                    <td> {{formatDate(packageDetails.add_date)}}</td>
                                                                    <td> {{convertMinutesToTime3(packageDetails.ageing)}}</td>
                                                                </tr>
                                                            </template>
                                                        </tbody>
                                                        <template v-if="!packages.length">
                                                            <tr>
                                                                <td colspan="6">No packages to show</td>
                                                            </tr>
                                                        </template>
                                                    </table>
                                                 </div>
                                            </div>
                                        </div>
                                        <div class="pageCenter text-center mt-4 pagination_viewallpages">
                                            <pagination v-model="page" :records="totalcount" :per-page="pagelimit" @paginate="(e) => handlePageChange(e, 'gate_entry_pass')"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                             
                         </div>

                    </div>
                </div>
            </section>
        </div>
    </div>
</div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import Pagination from 'vue-pagination-2'
import common_methods from "../utils/common_methods"
import CONSTANT from "../constants.js"
import searchMasterNameList from "../utils/searchMasterNameList"
import { ZoomInIcon, XIcon } from 'vue-feather-icons';

export default({
    name:'OutboundPlanView',
    mixins: [ common_methods, searchMasterNameList ],
    components: {
        VueElementLoading,
        Pagination,
        XIcon,
    },
    data() {
        return {
            isLoading: false,
            isFloorLoading: false,
            isPalletLoading: false,
            isPackagesLoading: false,
            isShipmentSummaryLoading: false,
            shipmentSummary: {
                total_shipments: 0,
                total_weight: 0,
                total_in_process: 0,
                not_scanned: 0
            },
            sequencer: [
                1, 13, 25,
                2, 14, 26,
                3, 15, 27,
                4, 16, 28,
                5, 17, 29,
                6, 18, 30,
                7, 19, 31,
                8, 20, 32,
                9, 21, 33,
                10, 22, 34,
                11, 23, 35,
                12, 24, 36
            ],
            no_of_days: 1,
            floors: [],
            docks: [],
            pallets: [],
            palletMaster: [],
            pallet_code: "",
            gate_entry_id: 0,
            packages: [],
            totalcount: 0,
            pageCount: 0,
            page: 1,
            pagelimit: CONSTANT.LIMIT,
            currPageNum: 0,
            pageoffset: 1,
            palletWeight: [],
            no_of_packages: 0,
            isPackageLoading: false,
            sector: "",
            dock: "",
            pallet: "",
        }  
    } ,
    mounted(){
       // this.getFloors()
        this.getFloorPlans()
        this.getShipmentSummary()
        // this.getPalletsOnSector()
        // this.getPackagesOnPallet()
    },
    methods: {
        resetPagination() {
            this.page = 1
            this.currPageNum = 0
            this.pageoffset = 1
            this.totalcount = 0
        },
        getPalletCode(pallets, index) {
            let currentLocationCode = index + 1 <= 9 ? `L0${index+1}`:`L${index+1}`
            if(pallets) {
                pallets = pallets.split(",")
            } else {
                return [currentLocationCode, false, currentLocationCode]
            }
            let pallet = pallets.find(p => p.split('___')[1] === currentLocationCode)
            if(pallet)  return [pallet.split('___')[0], true, currentLocationCode]
            return [currentLocationCode, false, currentLocationCode]
        },
        isNumber(evt, n) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
                evt.preventDefault();;
            } else {
                return true;
            }
        },
        getPackageNumbers(pallet_code) {
            this.pallet_code = pallet_code
            this.isPackageLoading = true
            let url = `/shipments/pallet-scan/${pallet_code}/unload`
            this.makeRequest("GET", url)
                .then(result => {
                    this.isPackageLoading = false
                    $('#exampleModalCenter').modal('show');
                    this.packages = result.data.data.packages
                    this.no_of_packages = result.data.data.result[0].no_of_packages
                })
                .catch(e => {
                    this.isPackageLoading = false
                    this.packages = []
                    this.number_of_packages = 0
                    // this.displayError(e)
                })
        },
        getWeightOnSector(ps) {
            if(!ps || (ps && !ps.length)) return ""
            let obj = ps[0].pallet_code.split(",")
            let pallets = []
            for(let pallet of obj) {
                if(!pallets.includes(pallet)) {
                    pallets.push(pallet)
                }
            }
            let weight = 0
            for(let pallet of pallets) {
                let searchPalletWeight = this.palletMaster.find(p => p.pallet_code == pallet)
                if(searchPalletWeight) {
                    weight += Number(searchPalletWeight.current_weight)
                }
            }
            return weight ? ` (${this.roundNumber(weight)} Kg)` : ""
        },
        getFloors() {
            this.isLoading = true
            let url = `/floors/get-all-floors`
            this.makeRequest("GET", url)
                .then(result => {
                    this.isLoading = false
                    this.floors = result.data.result
                    this.docks = result.data.docks
                    this.pallets = result.data.pallets
                    this.palletMaster = result.data.palletMaster
                })
                .catch(e => {
                    this.displayError(e)
                })
        },
        selectSector(e, sector, dock, index) {
            let allSectorListElements = document.getElementsByClassName("sector")
            for(let element of allSectorListElements) {
                element.classList.remove("active")
            }
            let sectorLiElement = e.target
            sectorLiElement.classList.add("active")
            if(this.dock === dock && this.sector === sector) {
                
            } else {
                this.page = 1
                this.currPageNum = 0
                this.pageoffset = 1
                this.totalcount = 0
                this.dock = dock
                this.sector = sector
                this.packages = []
                this.pallet = "-"
                this.gate_entry_id = 0
                this.getPalletsOnSector(sector, dock)
            }
        },
        selectPallet(e, pallet_code, gate_entry_id, index) {
            this.resetPagination()
            console.log('resetpasdflkj')
            let allPalletListElements = document.getElementsByClassName("pallet")
            for(let element of allPalletListElements) {
                element.classList.remove("active")
            }
            let palletElement = e.target
            palletElement.classList.add("active")
            if(this.pallet !== pallet_code) {
                this.packages = []
                this.pallet = pallet_code
                this.gate_entry_id = gate_entry_id
                this.getPackagesOnPallet(pallet_code, gate_entry_id)
            }
        },
        getShipmentSummary() {
            let no_of_days = Number(this.no_of_days)
            if(no_of_days > 365 || no_of_days < 1) {
                this.sweetAlertSnackbar("Number of days should be less then or equal to 365")
                return
            }
            this.isShipmentSummaryLoading = true
            let url = `/floor/shipment-summary?type=Outbound&no_of_days=${this.no_of_days}`
            this.makeRequest("POST", url)
                .then(result => {
                    this.isShipmentSummaryLoading = false
                    this.shipmentSummary = result.data.shipmentSummary[0]
                })
                .catch(e => {
                    this.isShipmentSummaryLoading = false
                    this.displayError(e)
                })
        },
        getFloorPlans() {
            this.isFloorLoading = true
            let url = `/floor/floor-plans?type=Outbound`
            this.makeRequest("POST", url)
                .then(result => {
                    this.isFloorLoading = false
                    this.floors = result.data.floors
                    if(this.floors.length) {
                        let floor = this.floors[0]
                        let dock = floor.dock_name
                        let zone_name = floor.zone_name ? floor.zone_name.split(",")[0] : "No sector to select"
                        // this.dock = dock
                        // this.sector = zone_name
                        setTimeout(() => {
                            let elem = document.getElementById(`${dock}___${zone_name}`)
                            if(elem) {
                                elem.click()
                            }

                        }, 500)
                    }
                })
                .catch(e => {
                    this.isFloorLoading = false
                    this.displayError(e)
                })
        },
        getPalletsOnSector(sector, dock_name) {
            this.isPalletLoading = true
            let url = `/floor/pallets?type=Outbound`
            this.makeRequest("POST", url, { sector, dock_name })
                .then(result => {
                    this.isPalletLoading = false
                    this.pallets = result.data.pallets
                    // if(this.pallets.length) {
                    //     let pallet = this.pallets[0].pallet_code
                    //     let pallets = pallet ? pallet.split(",") : []
                    //     if(pallets.length) {
                    //         let pallet_code = pallets[0]
                    //         let palletId = `${this.dock}___${this.sector}___${pallet_code}`
                    //         setTimeout(() => {
                    //             let palletElem = document.getElementById(palletId)
                    //             if(palletElem) {
                    //                 palletElem.click()
                    //             }
                    //         }, 500)
                    //     }
                    // }
                    this.palletWeight = result.data.palletWeight
                })
                .catch(e => {
                    this.isPalletLoading = false
                    this.displayError(e)
                })
        },
        getPackagesOnPallet(pallet_code, gate_entry_id) {
            this.isPackagesLoading = true
            let url = `/floor/pallets/packages`
            let payload = {
                page: this.page,
                rows: this.pagelimit
            }
            this.makeRequest("POST", url, { ...payload, pallet_code, gate_entry_id, sector: this.sector, dock_name: this.dock })
                .then(result => {
                    this.isPackagesLoading = false
                    this.packages = result.data.data.rows
                    this.totalcount = result.data.data.count
                    this.pageCount = Math.ceil(result.data.data.count / this.pagelimit)
                })
                .catch(e => {
                    this.isPackagesLoading = false
                    this.displayError(e)
                })
        },
        getTotalWeightOnSector() {
            return this.palletWeight.reduce((a, c) => a + Number(c.current_weight), 0)
        },
        getPalletCurrentWeight(pallet_code) {
            let obj = this.palletWeight.find(p => p.pallet_code === pallet_code)
            if(obj) {
                return Number(obj.current_weight)
            }
            return 0
        },
        handlePageChange(pageNum) {
            this.pageoffset=pageNum
            this.currPageNum = pageNum - 1

            this.getPackagesOnPallet(this.pallet, this.gate_entry_id);
            // setTimeout(() => {
            //     $('html, body').animate({
            //       scrollTop: $(`#${tab}`).offset().top -70
            //     });
            // }, 500);
        },
    }
})
</script>
<style scoped>
.high_weight {
    background-color: #F7993F;
    cursor: pointer;
    color: #292626;
    border-radius: 0px!important;
    border: 1px solid #d6811c;
}

.heavy {
    background-color: red;
    color: #fff;
}

li {
    list-style: none
}
.sector:hover, .pallet:hover {
    cursor: pointer;
    background-color: #19A873;
    color: #fff

}
.btn--export {
    border: none;
    padding: 6px 12px;
    color: #000;
    background: #fff;
    font-weight: 500
}
.btn--export:hover {
    color: #fff;
    background: #000
}
.top-badge {
    position: relative;
    left: 0px;
    top: 0px;
    background-color: #f9f9f9;
    border: 0.6px solid #cbcaca;
    color: #464646;
    padding: 0px 1px;
    font-size: 12px;
    border-radius: 2px;
}
</style>
